<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <p class=".title ma-2">Website price for {{ huis.huis_code }} </p>
      <v-form ref="websitePrice" v-model="websitePriceValid">
        <v-row no-gutters class="mx-2">
          <v-col cols="5" class="mx-2">
            <v-menu v-model="huis.verb_van_datMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="huis.verb_van_dat" label="Arrival date" clearable v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="hulpDate" :first-day-of-week="1"
                @input="huis.verb_van_dat = $moment(hulpDate).format('DD-MM-YYYY'); huis.verb_van_datMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="5" class="mx-2">
            <v-menu v-model="huis.verb_tm_datMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="huis.verb_tm_dat" label="Departure date" clearable v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="hulpDate" :first-day-of-week="1"
                @input="huis.verb_tm_dat = $moment(hulpDate).format('DD-MM-YYYY'); huis.verb_tm_datMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row no-gutters class="mx-2">
          <v-col cols="5" class="mx-2">
            <v-text-field v-model="huis.aant_volwkind" label="Number of Adults + Children" type="number"
              dense></v-text-field>
          </v-col>
          <v-col cols="5" class="mx-2">
            <v-text-field v-model="huis.aant_baby" label="Number of babies" type="number" dense></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="mx-2">
          <v-col cols="6" class="px-1">
            <v-select v-model="huis.inpt_code" :items="inpt_codeKeuzes" menu-props="auto" item-value="inpt_code"
              item-text="inpt_naam" label="Sales web partner"></v-select>
          </v-col>
        </v-row>
        <v-alert v-if="intervalError" type="error" dismissible class="mx-2" @input="intervalError = false">
          The interval between arrival and departure dates cannot be more than {{huis.aant_nacht_max}} days.
        </v-alert>
        <v-alert v-if="dateInputError" type="error" dismissible class="mx-2" @input="dateInputError = false">
          You need to have a start AND end date in order to get a decent calculation.
        </v-alert>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary mx-2" small @click="websitePrice" :disabled="intervalError||dateInputError">Save</v-btn>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      websitePriceValid: false,
      huis_encrid: null,
      hulpDate: '',
      inpt_codeKeuzes: [],
      intervalInDays: 0,
      huis: {
        verb_van_dat: '',
        verb_tm_dat: '',
        aant_volwkind: 0,
        aant_baby: 0,
        aant_nacht_max: 0,
        inpt_code: ''
      },
      intervalError: false,
      dateInputError: false
    }
  },
  methods: {
    open(huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huis_encrid = huis_encrid;
      this.$axios
        .post("ares/json/ares/huis/getHuisToWebsitePrice.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToWebsitePrice"
          },
          getHuisToWebsitePrice: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToWebsitePrice;
            this.inpt_codeKeuzes = res.data.getHuisToWebsitePrice.inpt_codeKeuzes;
            this.huis_encrid = huis_encrid;
          }
        })
    },
    checkDates() {
      if (!this.huis.verb_van_dat || !this.huis.verb_tm_dat) {
        this.dateInputError = true;
        return;
      }
      if (this.huis.verb_van_dat && this.huis.verb_tm_dat) {
        let startDate = this.$moment(this.huis.verb_van_dat, 'DD-MM-YYYY');
        let endDate = this.$moment(this.huis.verb_tm_dat, 'DD-MM-YYYY');
        this.intervalInDays = endDate.diff(startDate, 'days');
        if(this.intervalInDays > this.huis.aant_nacht_max){
          this.intervalError = true;
        } else {
          this.intervalError = false;
        }
      } else {
        this.intervalInDays = 0;
      }
    },
    websitePrice() {
      this.checkDates()
      if (this.intervalError || this.dateInputError) {
        setTimeout(() => {
          this.intervalError = false;
          this.dateInputError = false;
        }, 3000);
        return;
      }
      this.$axios
        .post("ares/json/ares/huis/websitePrice.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "websitePrice"
          },
          websitePrice: {
            huis_encrid: this.huis.huis_encrid,
            verb_van_dat: this.huis.verb_van_dat,
            verb_tm_dat: this.huis.verb_tm_dat,
            aant_volwkind: parseInt(this.huis.aant_volwkind),
            aant_baby: parseInt(this.huis.aant_baby),
            inpt_code: this.huis.inpt_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.websitePrice;
            window.open(this.huis.filename, '_blank');
            this.dialog = false;
          }
        })
    }
  }
}
</script>
